import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, List } from "antd";
import { observer } from "mobx-react";
import { PluginUpdateLicenseListItem } from "./licenseListItem.js";
import { __ } from "../../utils/i18n.js";
const PluginUpdateLicenseList = observer((param)=>{
    let { onDeactivate, pluginUpdate } = param;
    const { licensedEntries } = pluginUpdate;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(List, {
                itemLayout: "vertical",
                size: "small",
                dataSource: licensedEntries,
                renderItem: (license)=>/*#__PURE__*/ _jsx(PluginUpdateLicenseListItem, {
                        license: license,
                        onDeactivate: onDeactivate
                    })
            }),
            /*#__PURE__*/ _jsx("p", {
                style: {
                    textAlign: "right"
                },
                children: /*#__PURE__*/ _jsx(Checkbox, {
                    disabled: pluginUpdate.busy,
                    checked: pluginUpdate.announcementsActive,
                    onChange: (e)=>pluginUpdate.setAnnouncementActive(e.target.checked),
                    children: __("Show announcements for this plugin")
                })
            })
        ]
    });
});
export { PluginUpdateLicenseList };
